import { useEffect, useState } from 'react'
import { Col, Row, Card, Button, Form } from 'react-bootstrap'
import Swal from 'sweetalert2'
import api from '../../../../../config/AxiosInstance'
import Check from './components/Check'
import Select from 'react-select'
import { Save, Trash2 } from 'lucide-react'
import toast, { Toaster } from 'react-hot-toast'

const cardFilterStyle = {
  backgroundColor: '#fff',
  borderRadius: '12px',
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  padding: '1.5rem',
  marginBottom: '1.5rem'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

const customStyles = {
  control: (base, state) => ({
    ...base,
    background: '#fff',
    borderColor: state.isFocused ? '#f89d1d' : '#e9ecef',
    borderRadius: '8px',
    boxShadow: state.isFocused
      ? '0 0 0 0.2rem rgba(248, 157, 29, 0.25)'
      : 'none',
    fontSize: '0.9rem',
    padding: '2px',
    '&:hover': {
      borderColor: '#f89d1d'
    }
  }),
  placeholder: (base) => ({
    ...base,
    color: '#adb5bd'
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#f89d1d'
      : state.isFocused
        ? '#fff3cd'
        : null,
    color: state.isSelected ? 'white' : '#333',
    fontSize: '0.9rem',
    cursor: 'pointer',
    ':active': {
      ...base[':active'],
      backgroundColor: '#f89d1d'
    }
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 8px'
  }),
  input: (provided) => ({
    ...provided,
    margin: '0px'
  })
}

function ManageAccessPage() {
  const roleId = JSON.parse(localStorage.getItem('username')).role?.id
  const [roles, setRoles] = useState([])
  const [menus, setMenus] = useState([])
  const [selectRole, setSelectRole] = useState(null)

  const headerTitleStyle = {
    color: '#343a40',
    fontSize: '24px',
    fontWeight: '700'
  }

  useEffect(() => {
    getListRoles()
  }, [])

  const getListRoles = async () => {
    try {
      const res = await api.get('/cms/role/list/all')
      if (res.status === 200) {
        const filteredRoles = res.data.data.filter(
          (role) => !['RnR', 'LOAD', 'PnP'].includes(role.role_code)
        )
        const options = filteredRoles.map((r) => ({
          value: r.id,
          label: r.role_name
        }))
        setRoles(options)
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }

  const getMenus = async (role_id) => {
    try {
      const res = await api.post('/cms/manage-access/list_by_role', { role_id })
      if (res.status === 200) {
        setMenus(res.data.data)
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }

  const handleSelectRole = (opt) => {
    setSelectRole(opt)
    if (menus.length > 0 && !opt) setMenus([])
    if (opt) {
      getMenus(opt.value)
    }
  }

  const handleChangeChecked = (type, e, idParent = null) => {
    const { checked, value } = e.target
    const parentChecked = menus.find(
      (menu) => menu.id === (!idParent ? value : idParent)
    )
    if (type === 'parent') {
      parentChecked.is_checked = checked
      if (parentChecked.submenu.length > 0) {
        parentChecked.submenu.forEach((submenu) => {
          submenu.is_checked = checked
        })
      }
    }

    if (type === 'child') {
      const index = parentChecked.submenu.findIndex((menu) => menu.id === value)
      parentChecked.submenu[index].is_checked = checked
      const checkedLength = parentChecked.submenu.filter(
        (menu) => menu.is_checked
      ).length
      parentChecked.is_checked = checkedLength ? true : false
    }
    setMenus((prevMenus) =>
      prevMenus.map((menu) =>
        menu.id === parentChecked.id ? parentChecked : menu
      )
    )
  }

  const handleRemoveAll = () => {
    const uncheckedAll = menus.map((menu) => {
      menu.is_checked = false
      if (menu.submenu.length > 0) {
        menu.submenu.forEach((submenu) => {
          submenu.is_checked = false
        })
      }
      return menu
    })
    setMenus(uncheckedAll)
  }

  const handleSave = async () => {
    try {
      let data = {
        role_id: selectRole ? selectRole.value : '',
        access_ids: []
      }
      menus.forEach((menu) => {
        if (menu.is_checked) {
          data.access_ids.push(menu.id)
        }
        if (menu.submenu.length > 0) {
          menu.submenu.forEach((submenu) => {
            if (submenu.is_checked) {
              data.access_ids.push(submenu.id)
            }
          })
        }
      })

      if (data.access_ids.length <= 0) {
        return toast.error('Please select access for this role', {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
      }

      Swal.fire({
        text: 'Loading...',
        icon: 'warning',
        allowOutsideClick: false
      })
      const res = await api.post('/cms/manage-access/bulk_add_by_code', data)
      if (res.status === 200) {
        if (roleId === selectRole.value) {
          let dataLocalStorage = JSON.parse(localStorage.getItem('username'))
          dataLocalStorage = { ...dataLocalStorage, access: res.data.data }
          localStorage.setItem('username', JSON.stringify(dataLocalStorage))
        }
        toast.success(res.data.message, {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setTimeout(() => {
        Swal.close()
      }, 3000)
    }
  }

  return (
    <div className="container-fluid px-4 mb-5">
      <Row className="mb-4 align-items-center">
        <Col>
          <h3 style={headerTitleStyle}>Access Management</h3>
        </Col>
        {selectRole && (
          <Col className="text-end">
            <div className="d-flex justify-content-end gap-2">
              <Button
                variant="danger"
                size="sm"
                className="rounded px-3 py-2 fw-bold text-uppercase"
                onClick={handleRemoveAll}
                disabled={!selectRole}
              >
                <Trash2 size={16} className="me-2" />
                Remove All
              </Button>
              <Button
                variant="success"
                size="sm"
                className="rounded px-3 py-2 fw-bold text-uppercase"
                onClick={handleSave}
                disabled={!selectRole}
              >
                <Save size={16} className="me-2" />
                Save Changes
              </Button>
            </div>
          </Col>
        )}
      </Row>

      <Card style={cardFilterStyle}>
        <Row>
          <Col md={12}>
            <Form.Group>
              <Form.Label style={labelStyle}>Select Role</Form.Label>
              <Select
                options={roles}
                value={selectRole}
                onChange={(opt) => handleSelectRole(opt)}
                placeholder="Choose a Role"
                styles={customStyles}
                isClearable
              />
            </Form.Group>
          </Col>
        </Row>
      </Card>

      {selectRole && menus.length > 0 && (
        <Card className="border-0 shadow-sm rounded-4 p-4">
          <Row>
            <Col>
              {menus.map((menu) => (
                <Check
                  data={menu}
                  subMenu={menu.submenu}
                  key={menu.id}
                  handleChangeChecked={handleChangeChecked}
                />
              ))}
            </Col>
          </Row>
        </Card>
      )}

      <Toaster />
    </div>
  )
}

export default ManageAccessPage
